import script from "./UploadView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadView.vue?vue&type=script&setup=true&lang=ts"

import "./UploadView.vue?vue&type=style&index=0&id=d83ea260&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d83ea260"]])

export default __exports__